import { ComponentIds, HierarchyUtils, } from "@inter-ikea-core/core";
import { SystemBase } from "@inter-ikea-core/core-toolbox";
import { adjustMergeAlignmentConnector } from "../functions/Alignment";
import { getUprights } from "../utils/sectionsHelpers";
import MountingRailComponent from "../components/MountingRailComponent";
import { getRootMountingRails } from "../utils/getEntityData";
export default class AddAlignmentToMountingRailSystem extends SystemBase {
    constructor(_core) {
        super(ComponentIds.GUEST_CONNECTIONS_COMPONENT_ID);
        this._core = _core;
        this.doingChangesOnComponent = [];
        this.systemsBeforeMe = null;
        this.systemsAfterMe = null;
        this.id = "AddAlignmentToMountingRailSystem";
    }
    onAddComponent(_entity, _newComponent) {
        this.addAlignment(_entity);
    }
    onUpdateComponent(_entity) {
        this.addAlignment(_entity);
    }
    onRemoveComponent(_entity) {
        getRootMountingRails(this._core).map((mountingRail) => this.addAlignment(mountingRail));
    }
    addAlignment(_entity) {
        const mountingRail = _entity.hasComponent(MountingRailComponent.id)
            ? _entity
            : HierarchyUtils.parent(_entity);
        if (!mountingRail)
            return;
        const { leftUpright, rightUpright } = getUprights(mountingRail);
        if (!leftUpright || !rightUpright || !HierarchyUtils.parent(mountingRail))
            return;
        adjustMergeAlignmentConnector(mountingRail);
    }
}
